var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.12109V14.1411L2.65 20.6811C1.8 19.6711 1.75 18.1411 2.7 16.4311L5.82 10.8211L8.76 5.53109C9.65 3.93109 10.82 3.12109 12 3.12109Z",
    fill: "#FF8F53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M21.3504 20.6806C20.7004 21.4706 19.5704 21.9406 18.0604 21.9406H5.94039C4.43039 21.9406 3.30039 21.4706 2.65039 20.6806L12.0004 14.1406L21.3504 20.6806Z",
    fill: "#FF8F53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.35 20.6811L12 14.1411V3.12109C13.18 3.12109 14.35 3.93109 15.24 5.53109L18.18 10.8211L21.3 16.4311C22.25 18.1411 22.2 19.6711 21.35 20.6811Z",
    fill: "#FF8F53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon3);
export default __webpack_public_path__ + "static/media/feature-icon-3.78a514cb0c824697160f4814c7de2b60.svg";
export { ForwardRef as ReactComponent };